// FTEDN — useAuth hook
import { useAuthStore } from '../stores/auth.store';

export function useAuth() {
  const {
    user,
    isAuthenticated,
    isLoading,
    login,
    loginWithGoogle,
    signup,
    startPhoneSignup,
    confirmPhoneSignup,
    skipPhonePrompt,
    logout,
  } = useAuthStore();

  return {
    user,
    isAuthenticated,
    isLoading,
    login,
    loginWithGoogle,
    signup,
    startPhoneSignup,
    confirmPhoneSignup,
    skipPhonePrompt,
    logout,
    userId: user?.id || null,
    displayName: user?.displayName || 'Creator',
  };
}
